/***
 * @file:
 * @author: haoxianhuan
 * @Date: 2021-08-04 15:53:33
 */
import { Component, EventEmitter, forwardRef, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  selector: 'dt-table-base',
  templateUrl: './table-base.component.html',
  styleUrls: ['./table-base.component.scss'],
})
export class TableBaseComponent implements OnInit {
  @Input() tableData: any[] = [{}];
  @Input() isCreate = false;
  @Input() operationWidth: string;
  @Input() controls = [];
  @Input() title = '';
  @Input() hasDelete = false;
  @Input() scrollY = '';
  @Input() scrollX = '';
  // æ°æ®ååè§¦å
  @Output() valueChange = new EventEmitter<any>();
  // ç¹å»åè¡¨åå¸¦æåç¼åç´ è§¦å
  @Output() afterClick = new EventEmitter<any>();
  @Output() beforeClick = new EventEmitter<any>();
  @Output() itemClick = new EventEmitter<any>();
  heads = [];
  headMap: any;
  @Input() set head(headData: any) {
    if (Array.isArray(headData)) {
      this.heads = headData;
      this.headMap = {};
    } else if (typeof headData === 'object') {
      this.heads = [];
      this.headMap = headData;
    }
  }
  constructor() {}
  ngOnInit() {}
  onValueChange(data) {
    this.valueChange.emit(data);
  }
  tableAfterClick($event) {
    this.afterClick.emit($event);
  }
  tableBeforeClick($event) {
    this.beforeClick.emit($event);
  }
  tableItemClick($event) {
    this.itemClick.emit($event);
  }
}
